<template>
    <div>
        <game-detail :details='details'></game-detail>
    </div>
</template>

<script>
import gameDetail from '../../components/gamedetail/gamedetail'

import logo_img from '../../images/xianlaigame/xl_yn.png'
import ercodeimg from '../../images/gamecenter_ercode/ercode_yn.png'
import list_img1 from '../../images/download/down-yn1.png'
import list_img2 from '../../images/download/down-yn2.png'
import list_img3 from '../../images/download/down-yn3.png'
import cut_img1 from '../../images/download/ynjt1.jpg'
import cut_img2 from '../../images/download/ynjt2.jpg'
import cut_img3 from '../../images/download/ynjt3.jpg'
export default {
    data(){
        return{
            details:{
                logo_img:logo_img,
                name:'山水云南麻将',
                size:'64.21',
                load_count:'507',
                desp:'云南麻将的规则体系和历史发展源远流长，在不同地区也有不同的玩法。比如曲靖流行“飞小鸡”玩法，丽江地区流行“卡五心”玩法。',
                ios_url:'http://app6.auwvnd.cn/?downloadfrom=yunnan',
                android_url:'http://app6.auwvnd.cn/?downloadfrom=yunnan',
                ercodeimg:ercodeimg,
                list_img1:list_img1,
                list_img2:list_img2,
                list_img3:list_img3,
                cut_img1:cut_img1,
                cut_img2:cut_img2,
                cut_img3:cut_img3
            }
        }
    },
    components:{
        gameDetail
    }
}
</script>

<style scoped>

</style>
